import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../img/logo.png";

export const HeaderComponent = () => {
  return (
    <Navbar expand="lg" className="bg-body-tertiary" sticky="top">
      <Container fluid>
        <Navbar.Brand
          href="/"
          className="d-flex align-items-center text-center"
        >
          <img
            src={Logo}
            alt="banner"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "600px", // o un valor razonable
              display: "block",
              margin: "0 auto",
              
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="border-0"
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            {" "}
            
            <Nav.Link
              href="/"
              className="px-3 py-2 nav-link-custom"
            >
              Inicio
            </Nav.Link>
            
            {/* Puedes agregar más enlaces aquí */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderComponent;
